export class GetActionApprovalSummaryResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "hasPolicies",
            "baseName": "hasPolicies",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "requestsCount",
            "baseName": "requestsCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "myRequestsCount",
            "baseName": "myRequestsCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetActionApprovalSummaryResponse.attributeTypeMap;
    }
    constructor() {
    }
}
